import React, { Component, Fragment } from 'react';
import { Button, Modal, Icon, message, Switch, Alert, Tag, Radio } from 'antd';
import Convert from '../../convert';
import Calculations from '../../calculations'
import SplitPane from 'react-split-pane';
import InputField from '../../components/global/InputField';
import PlugwrapThickness from '../../components/PlugwrapThickness';
import './towItemSelectionForm.css';
import TowItemGrid from '../TowItemGrid';
import { connect } from 'react-redux';
import { loadTowItems } from '../../actions'
import PropTypes from 'prop-types';
import { CustomGraph } from '../../components/custom-graph';
import html2canvas from 'html2canvas';
import randomcolor from 'randomcolor';
import Translation from '../../Translation';
import { utils } from '../../config';

/**
 *
 * Towitemselection is for tow item selection
 *
 * @class TowItemSelectionForm
 * @extends {Component}
 */
class TowItemSelectionForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pref: {
                capsule: {
                    0: {
                        weight: '(mg/rod)',
                        lowpdlim: ['(mm H₂O/rod)', '(pa/rod)']
                    },
                    1: {
                        weight: '(mg/capsule)',
                        lowpdlim: ['(mm H₂O/capsule)', '(pa/capsule)']
                    }
                },
                weight: ['(g/100)', '(mg)', '(g)'],
                lowpdlim: ['(mm H₂O)', '(pa)'],
                lowpdCarbonlim: ['(mm H₂O/mm)', '(pa/mm)'],
                pz: ['% Dry Basis', '% Wet Basis'],
                pivmaxlim: ['(Tow Weight)', '(Wet Weight)'],
                rodmaker: {
                    3: '200 - 600 m/min',
                    2: '100 - 200 m/min',
                    1: '&lt; 100 m/min'
                }
            },
            lines: [],
            preferences: this.props.preferences,
            length: 0,
            circumference: 0,
            diameter: 0,
            pressureDrop: 0,
            plasticizer: 0,
            dpfFrom: 0,
            dpfTo: 0,
            plugwrapThicknessVal: 0.039,
            pgWeight: 0,
            towRange: 0,
            acceptableRangeFrom: 0,
            acceptableRangeTo: 100,
            dpf: 0,
            td: 0,
            isCarbonChecked: false,
            isCapsuleChecked: false,
            isNewTowItemChecked: false,
            newTowItemDisplay: 'displayNone',
            carbonDisplay: 'displayNone',
            capsuleDisplay: 'displayNone',
            capsuleMode: "1",
            capsuleWt: 0,
            epdCarbon: 0,
            capsulePD: 0,
            capsuleNo: 0,
            carbonRange: 0,
            carbonLoading: 0,
            carbonPir: 0,
            carbonWt: 0,
            show: false,
            rows: [],
            tableHeaders: [],
            selectedItems: [],
            selectedRows: [],
            defaultHeaders: [],
            carbonHeaders: [],
            defaultData: [],
            defaultSelectedItems: ['45.9, 46.1'],
            isTableSelectable: true,
            isTowRange: false,
            isPaperGlue: true,
            isCarbonRange: false,
            isSize: false,
            visibleplugwrap: false,
            isCarbonLoaded: false,
            height: 300,
            toggleTable: true,
            isPropsData: false,
            itemLotVal: '',
            loadItemsClick: false,
            splitVertical: 400,
            collapse: true,
            toFilterTowItemData: {}
        };

        this.updatePlugwrapValue = this.updatePlugwrapValue.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.hidePlugwrapModal = this.hidePlugwrapModal.bind(this);
        this.onSelectedChange = this.onSelectedChange.bind(this);
        this.toggleCarbonCheck = this.toggleCarbonCheck.bind(this);
        this.toggleCapsuleMode = this.toggleCapsuleMode.bind(this);
        this.toggleCapsuleCheck = this.toggleCapsuleCheck.bind(this);
        this.toggleNewTowItemCheck = this.toggleNewTowItemCheck.bind(this);
        this.updateHeaderRow = this.updateHeaderRow.bind(this);
        this.viewSelectedItems = this.viewSelectedItems.bind(this);
        this.toggleDisplayForNewTowItem = this.toggleDisplayForNewTowItem.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.getSelectedItems = this.getSelectedItems.bind(this);
        this.toggleDisplayForCarbon = this.toggleDisplayForCarbon.bind(this);
        this.onLoadItemsClick = this.onLoadItemsClick.bind(this);
        this.toggleTowRange = this.toggleTowRange.bind(this);
        this.togglePaperGlue = this.togglePaperGlue.bind(this);
        this.toggleEPDCarbon = this.toggleEPDCarbon.bind(this);
        this.toggleCarbonRange = this.toggleCarbonRange.bind(this);
        this.onRowsSelected = this.onRowsSelected.bind(this);
        this.handlePlugwrapCancel = this.handlePlugwrapCancel.bind(this);
        this.handleLengthChange = this.handleLengthChange.bind(this);
        this.calculateUserRange = this.calculateUserRange.bind(this);
        this.onSplitChange = this.onSplitChange.bind(this);
        this.onCarbonLoadBlur = this.onCarbonLoadBlur.bind(this);
        this.collapseLeft = this.collapseLeft.bind(this);
        this.collapseRight = this.collapseRight.bind(this);
    }
    /**
     * clearForm clears the form and fills the input field with the default values
     *
     * @param {*} e
     * @memberof TowItemSelectionForm
     */
    clearForm(e) {
        e && e.preventDefault();

        this.setState({
            length: 0,
            towRange: 0,
            circumference: 0,
            diameter: 0,
            pressureDrop: 0,
            plasticizer: 0,
            epdCarbon: 0,
            dpfFrom: 0,
            dpfTo: 0,
            acceptableRangeFrom: 0,
            acceptableRangeTo: 100,
            plugwrapThicknessVal: 0.042,
            isCarbonChecked: false,
            isNewTowItemChecked: false,
            newTowItemDisplay: 'displayNone',
            carbonDisplay: 'displayNone',
            pgWeight: 0,
            carbonLoading: 0,
            carbonWt: 0,
            carbonRange: 0,
            dpf: 0,
            td: 0,
            carbonPir: 0
        });
        sessionStorage.removeItem('towItemSelectionData');
    }

    // toggling the carbon checkbox
    /**
     *toggleCarbonCheck function toggles the carbon checkbox and calls updateHeaderRow function
     *
     * @memberof TowItemSelectionForm
     */
    toggleCarbonCheck() {
        this.setState({
            isCarbonChecked: !this.state.isCarbonChecked,
            isCapsuleChecked: this.state.isCarbonChecked && false
        }, function () {
            this.updateHeaderRow();
            this.toggleDisplayForCarbon();
        });
    }

    // toggling the Capsule checkbox
    /**
     *toggleCapsuleCheck function toggles the carbon checkbox and calls updateHeaderRow function
     *
     * @memberof TowItemSelectionForm
     */
    toggleCapsuleCheck() {
        this.setState({
            isCapsuleChecked: !this.state.isCapsuleChecked,
            isCarbonChecked: this.state.isCapsuleChecked && false
        }, function () {
            this.updateHeaderRow();
            this.toggleDisplayForCapsule();
        }
        );
    }

    /**
     *  toggleDisplayForcarbon function toggle the carbon Display
     *
     * @memberof TowItemSelectionForm
     */
    toggleDisplayForCarbon() {
        if (this.state.isCarbonChecked) {
            this.setState({
                carbonDisplay: 'displayBlock',
                capsuleDisplay: 'displayNone'
            });
        }
        else {
            this.setState({
                carbonDisplay: 'displayNone'
            });
        }
    }
    /**
     *  toggleDisplayForcarbon function toggle the carbon Display
     *
     * @memberof TowItemSelectionForm
     */
    toggleDisplayForCapsule() {
        if (this.state.isCapsuleChecked) {
            this.setState({
                capsuleDisplay: 'displayBlock',
                carbonDisplay: 'displayNone'
            });
        }
        else {
            this.setState({
                capsuleDisplay: 'displayNone'
            });
        }
    }
    /**
     *collapseLeft collapses the towitem form
     *
     * @param {*} evt
     * @memberof TowItemSelectionForm
     */
    collapseLeft(evt) {
        evt.preventDefault();
        this.setState({ splitVertical: 45, collapse: false });
    }

    collapseRight(evt) {
        evt.preventDefault();
        this.setState({ splitVertical: 400, collapse: true });
    }
    /**
     * toggleDisplayForNewTowItem function toggles between the new tow item
     *
     * @memberof TowItemSelectionForm
     */
    toggleDisplayForNewTowItem() {
        if (this.state.isNewTowItemChecked) {
            this.setState({
                newTowItemDisplay: 'displayBlock'
            });
        }
        else {
            this.setState({
                newTowItemDisplay: 'displayNone'
            });
        }
    }

    /**
     * toggleNewTowItemCheck toggles the newitem checkbox
     *
     * @memberof TowItemSelectionForm
     */
    toggleNewTowItemCheck() {
        this.setState({ isNewTowItemChecked: !this.state.isNewTowItemChecked }, function () {
            this.toggleDisplayForNewTowItem();
            this.setState({
                toFilterTowItemData: {
                    ...this.state.toFilterTowItemData,
                    dpf: this.state.isNewTowItemChecked ? this.state.dpf : 0,
                    td: this.state.isNewTowItemChecked ? this.state.td : 0
                }
            });
        });
    }
    /**
     * toggleTowRange function enables the input field of the weight range and call calculateUserRange function
     *
     * @memberof TowItemSelectionForm
     */
    toggleTowRange() {
        this.setState({ isTowRange: !this.state.isTowRange }, function () {
        });


        this.calculateUserRange();
    }
    /**
     * togglePaperGlue  enables the input field of the paper glue
     *
     * @memberof TowItemSelectionForm
     */
    togglePaperGlue() {
        this.setState({ isPaperGlue: !this.state.isPaperGlue }, function () {
        });
    }

    /**
     *
     * toggleCarbonRange enables the input field of max carbon load
     * @memberof TowItemSelectionForm
     */
    toggleCarbonRange() {
        this.setState({ isCarbonRange: !this.state.isCarbonRange }, function () {
        });
    }

    toggleCapsuleMode(e) {
        this.setState({
            capsuleMode: e.target.value
        })
    }

    /**
     *
     * toggleEPDCarbon enables the input field of max carbon load
     * @memberof TowItemSelectionForm
     */
    toggleEPDCarbon() {
        this.setState({ isEPDCarbon: !this.state.isEPDCarbon }, function () {
        });
    }
    /**
     * onLoadItemsClick function calles doTowItemCalculation function
     *
     * @param {*} e
     * @memberof TowItemSelectionForm
     */
    onLoadItemsClick(e) {
        e && e.preventDefault();
        this.props.onTowItemsSelected(this.state);
        this.doTowItemCalculations();
        this.setState({
            isCarbonLoaded: this.state.isCarbonChecked,
            lines: [],
            loadItemsClick: true,
            toFilterTowItemData: {
                length: this.state.length,
                circumference: this.state.circumference,
                diameter: this.state.diameter,
                pressureDrop: this.state.pressureDrop,
                plasticizer: this.state.plasticizer,
                dpfFrom: this.state.dpfFrom,
                dpfTo: this.state.dpfTo,
                plugwrapThicknessVal: this.state.plugwrapThicknessVal,
                pgWeight: this.state.pgWeight,
                towRange: this.state.towRange,
                acceptableRangeFrom: this.state.acceptableRangeFrom,
                acceptableRangeTo: this.state.acceptableRangeTo,
                dpf: this.state.isNewTowItemChecked ? this.state.dpf : 0,
                td: this.state.isNewTowItemChecked ? this.state.td : 0,
                isCarbonChecked: this.state.isCarbonChecked,
                isNewTowItemChecked: this.state.isNewTowItemChecked,
                carbonRange: this.state.carbonRange,
                carbonLoading: this.state.carbonLoading,
                carbonWt: this.state.carbonWt,
                isPaperGlue: this.state.isPaperGlue,
                isCarbonRange: this.state.isCarbonRange,
                isCarbonLoaded: this.state.isCarbonLoaded,
                isTowRange: this.state.isTowRange
            }
        });
        if (!this.state.isPropsData) {
            let loadingData = {
                length: this.state.length,
                circumference: this.state.circumference,
                diameter: this.state.diameter,
                pressureDrop: this.state.pressureDrop,
                plasticizer: this.state.plasticizer,
                dpfFrom: this.state.dpfFrom,
                dpfTo: this.state.dpfTo,
                plugwrapThicknessVal: this.state.plugwrapThicknessVal,
                pgWeight: this.state.pgWeight,
                towRange: this.state.towRange,
                acceptableRangeFrom: this.state.acceptableRangeFrom,
                acceptableRangeTo: this.state.acceptableRangeTo,
                dpf: this.state.dpf,
                td: this.state.td,
                isCarbonChecked: this.state.isCarbonChecked,
                isNewTowItemChecked: this.state.isNewTowItemChecked,
                isEPDCarbon: this.state.isEPDCarbon,
                epdCarbon: this.state.epdCarbon,
                newTowItemDisplay: this.state.newTowItemDisplay,
                carbonDisplay: this.state.carbonDisplay,
                carbonRange: this.state.carbonRange,
                carbonLoading: this.state.carbonLoading,
                carbonPir: this.state.carbonPir,
                carbonWt: this.state.carbonWt,
                isPaperGlue: this.state.isPaperGlue,
                isTowRange: this.state.isTowRange,
                isCarbonRange: this.state.isCarbonRange,
                isCapsuleChecked: this.state.isCapsuleChecked,
                capsuleMode: this.state.capsuleMode,
                capsuleDisplay: this.state.capsuleDisplay,
                capsuleWt: this.state.capsuleWt,
                capsulePD: this.state.capsulePD,
                capsuleNo: this.state.capsuleNo
            };
            loadingData = JSON.stringify(loadingData);
            if (!this.props.isPropsData) {
                sessionStorage.setItem('towItemSelectionData', loadingData);
            }
        }
    }

    isValidForm() {
        return (this.state.length &&
            (this.state.circumference || this.state.diameter) &&
            (this.state.isCarbonChecked && this.state.carbonRange))
    }



    // checks the state of the carbon checkbox
    // populates the table accordingly
    /**
     * updateHeaderRow checks the state of the carbon checkbox and
     * populates the table accordingly
     *
     * @memberof TowItemSelectionForm
     */
    updateHeaderRow() {
        if (this.state.isCarbonChecked) {
            this.setState({ isTableSelectable: true }, () => {
                this.setState({
                    tableHeaders: this.state.carbonHeaders,
                    rows: this.state.defaultData,
                    selectedRows: []
                });
            });
        }
        else {

            this.setState({ isTableSelectable: true }, () => {
                this.setState({
                    tableHeaders: this.state.defaultHeaders,
                    rows: this.state.defaultData,
                    selectedRows: []
                });
            });
        }
    }
    /**
     *assignData function is for getting the tow items data from redux/store
     *
     * @memberof TowItemSelectionForm
     */
    assignData = (nextProps) => {
        if (nextProps.itemData) {
            this.setState({ towItems: nextProps.itemData }, function () {
                if (this.props.towItemProps && parseFloat(this.props.towItemProps.length) > 0) {
                    this.onLoadItemsClick();
                }
            });
        }
    }
    /**
     * checkIsValid checks if the input field of the tow item selection from has valid data
     *
     * @param {object} input
     * @param {object} towItem
     * @returns
     * @memberof TowItemSelectionForm
     */
    checkIsValid(input, towItem) {

        if (input.rodepd === 0) {
            towItem.gphtgtwt = 0;
            towItem.gphtgtpd = 0;
            towItem.lotpir = 0;
            input.minrange = 0;
            towItem.Cmodel_tgtWgt = 0;
            towItem.Cmodel_pir = 0;
            towItem.firmness = 0;
        }

        let lotpir = towItem.lotpir;
        let tipcirc = towItem.tipcirc;
        let td = towItem.lotatd;
        let Cmodel_pir = towItem.Cmodel_pir;
        let ndpf = towItem.ndpf;
        let minrange = input.minrange;
        let maxrange = input.maxrange;


        if (lotpir < 0 || lotpir > 100 || Cmodel_pir < 0 || Cmodel_pir > 100) {
            return false;
        }

        if ((ndpf < 5 && td > 30000 && tipcirc < 19) || (ndpf > 6 && td < 20000 && tipcirc > 21)) {

            return false;
        }

        if (lotpir < minrange || lotpir > maxrange) {
            return false;
        }

        return true;
    }
    /**
     * handlePlugwrapCancel closes the plugwrap window
     *
     * @memberof TowItemSelectionForm
     */
    handlePlugwrapCancel = () => {
        this.setState({
            visibleplugwrap: false
        });
    }
    /**
     * showPlugwrapModal displays the plugwrap window
     *
     * @memberof TowItemSelectionForm
     */
    showPlugwrapModal = () => {
        this.setState({
            visibleplugwrap: true
        });
    }
    /**
     * updatePlugwrapValue fills the input field with the plugwrap data selected
     * from thw plugwrap window
     *
     * @param {*} data
     * @memberof TowItemSelectionForm
     */
    updatePlugwrapValue(data) {
        this.setState({
            plugwrapThicknessVal: data
        });
    }

    showModal() {
        this.setState({ show: true });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            }, () => {
                this.calculateUserRange();
                if (((parseFloat(this.state.length) &&
                    (parseFloat(this.state.circumference) || parseFloat(this.state.diameter)) &&
                    (this.state.isCarbonChecked ? this.state.carbonLoading : true)) &&
                    (this.state.isNewTowItemChecked ? (parseFloat(this.state.td) && parseFloat(this.state.dpf)) : true) &&
                    (this.state.dpfTo)
                )) {
                    this.onLoadItemsClick();
                }
            })
        }
        if (nextProps && nextProps.towItemProps) {
            this.loadTowSelectionData(nextProps.towItemProps);
            if (this.state.towItems.length && parseFloat(nextProps.towItemProps.length) > 0) {
                setTimeout(() => { this.toggleDisplayForCarbon(); this.onLoadItemsClick() }, 300);
            }
        }
    }

    componentWillMount() {
        this.loadTowSelectionData(this.props.towItemProps);
        this.assignData(this.props);
    }

    loadTowSelectionData(propsData) {
        if (this.props.isPropsData) {
            if (Object.keys(propsData).length > 0) {
                this.setState({ ...propsData }, function () {
                    this.setState({
                        isPropsData: true
                    });
                });
            }
            return;
        }

        let cacheData = sessionStorage.getItem('towItemSelectionData');

        if (cacheData) {

            try {
                cacheData = JSON.parse(cacheData);
                this.setState({ ...cacheData });
            } catch (e) {
                //do nothing
            }
        }

    }
    /**
     * calculateUserRange calls the function onCarbonLoadBlur
     *
     * @memberof TowItemSelectionForm
     */
    calculateUserRange() {

        this.onCarbonLoadBlur();
    }
    /**
     * doTowItemCalculations function takes all input field values and user prefernces , convert
     * units to standard celanese values and performs the calculations
     *
     * @memberof TowItemSelectionForm
     */
    doTowItemCalculations() {
        var finals = [];
        var newTowItem = {};
        var isUser = this.props.userRole.toLowerCase() === 'user';
        var input = {
            rodlen: parseFloat(this.state.length),
            tipcirc: parseFloat(this.state.circumference),
            dpfto: parseFloat(this.state.dpfTo),
            dpffrom: parseFloat(this.state.dpfFrom),
            rodepd: parseFloat(this.state.pressureDrop),
            pz: parseFloat(this.state.plasticizer),
            pwthick: parseFloat(this.state.plugwrapThicknessVal),
            minrange: parseFloat(this.state.acceptableRangeFrom),
            maxrange: parseFloat(this.state.acceptableRangeTo),
            newTowItem: this.state.isNewTowItemChecked
        }

        var preferences = Object.assign({}, this.state.preferences);

        if (preferences.size === 1) {
            input.tipcirc = parseFloat(this.state.circumference) || 0;
        } else {
            input.tipcirc = parseFloat(this.state.diameter) || 0;
        }

        if (input.newTowItem) {
            input.dpf = parseFloat(this.state.dpf) || 0;
            input.td = parseFloat(this.state.td) || 0;
        }

        if (this.state.isCapsuleChecked) {
            let capsWt, capsPD;
            //per capsule
            if (this.state.capsuleMode === "1") {
                capsWt = this.state.capsuleWt * this.state.capsuleNo / input.rodlen;
                capsPD = this.state.capsulePD * this.state.capsuleNo / input.rodlen;
            }
            // per filter rod
            else {
                capsWt = this.state.capsuleWt / input.rodlen;
                capsPD = this.state.capsulePD / input.rodlen;
            }
            input.cload = capsWt;
            input.epdCarbon = capsPD;
        }

        if (this.state.isCarbonChecked) {
            input.uscrange = parseFloat(this.state.carbonRange) || 0;
            input.cload = parseFloat(this.state.carbonLoading) || 0;
            input.epdCarbon = parseFloat(this.state.epdCarbon) || 0;
        }

        if (this.state.isPaperGlue) {
            input.rodpgwt = parseFloat(this.state.pgWeight) || 0;
            preferences.pivmaxlim = 2;
        }

        if (this.state.isTowRange) {
            input.usrange = parseFloat(this.state.towRange) || 0;
        }

        input.usrRangeLenEnabled = this.state.isTowRange;
        input.carbRangeLenEnabled = this.state.isCarbonRange;

        var towItems = [...this.state.towItems];

        towItems = towItems.filter(towItem => {
            return (!(towItem.duplicate && !isUser) && (towItem.nompf >= input.dpffrom && towItem.nompf <= input.dpfto));
        });
        var calculations = Calculations(preferences);

        if (input.newTowItem) {
            newTowItem = Object.assign({}, input);
            newTowItem = calculations.newTowItem(newTowItem);
            towItems.unshift(newTowItem);
        }

        calculations.EPDBiasCorrection(input);

        //convert the units to standard celanese values
        input = this.convertToCelaneseValues(input);

        for (var key in towItems) {

            var final = Object.assign({}, input, towItems[key]);
            final.ndpf = final.lotadpf;

            if (final.itmcirc) {
                final.stdcirc = final.itmcirc
            }

            if (final.stdpwth) {
                final.stdthick = final.stdpwth
            }

            if (!final.isNew) {
                calculations.slopeAndIntercept(final);
                calculations.minPtAdjustmentByPlant(final);
            }

            calculations.yieldPredictionModel(final);
            calculations.rangeExtension(final);
            calculations.predictPDIncreaseByPZ(final);

            if (final.cload) {
                calculations.predictCarbonCapabilities(final);
                calculations.predictCarbonCapabilityLoad(final);
                if (this.state.isEPDCarbon || this.state.isCapsuleChecked) {
                    calculations.predictCarbonCapabilityLoadManual(final);
                }
                calculations.predictMaxCarbonLoading(final);
            }

            calculations.targetPD(final);

            calculations.firmness(final);
            calculations.firmnessCured(final);

            if (preferences.pivmaxlim === 2) {
                calculations.adjustWeightToWetWeight(final);
            }

            calculations.AdjDepPresDrop(final);
            calculations.EPDBiasCorrectionsRevert(final);

            if (this.checkIsValid(input, final)) {
                finals.push(final);
            }
        }

        var showTowItems = this.prepareData(finals);
        if (showTowItems.length > 0) {
            this.setState({
                calculatedTowItems: showTowItems,
                toggleTable: false
            })
        }
        else {
            this.setState({ toggleTable: true });
            message.error(utils.getTranslationText('msg_error_tow_items', 'No tow items found meeting the search criteria. Please adjust the search params'));
        }
    }

    prepareData(finals) {
        var newFinals = [];
        var towItem;
        for (var towKey in finals) {
            towItem = finals[towKey];
            newFinals.push({
                itemlot: towItem.itemlot,
                item: towItem.item,
                lot: towItem.lot,
                cload: towItem.cload,
                plant: towItem.plantcode,
                status: towItem.status,
                crange: towItem.crange,
                color: randomcolor({
                    luminosity: 'bright',
                    format: 'rgb'
                }),
                minwt: {
                    normal: parseFloat(towItem.gphminwt.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_tgtC_minwt.toFixed(2))
                },
                maxwt: {
                    normal: parseFloat(towItem.gphmaxwt.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_tgtC_maxwt.toFixed(2))
                },
                tgtwt: {
                    normal: parseFloat(towItem.gphtgtwt.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_tgtWgt.toFixed(2))
                },
                minpd: {
                    normal: parseFloat(towItem.gphminpd.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_tgtC_minEPD.toFixed(2))
                },
                maxpd: {
                    normal: parseFloat(towItem.gphmaxpd.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_tgtC_maxEPD.toFixed(2))
                },
                tgtpd: {
                    normal: parseFloat(towItem.gphtgtpd.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_tgtEPD.toFixed(2))
                },
                rangeextn: {
                    normal: parseFloat(towItem.range_ext.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_range_ext.toFixed(2))
                },
                pir: {
                    normal: parseFloat(towItem.lotpir.toFixed(2)),
                    carbon: towItem.cload && parseFloat(towItem.Cmodel_pir.toFixed(2))
                },
                firmness: !isNaN(towItem.firmness) ? parseFloat(towItem.firmness.toFixed(2)) : 0
            });
        }
        return newFinals;

    }

    onCarbonLoadBlur() {
        let carbonWt = this.state.length * this.state.carbonLoading;

        this.setState({
            carbonWt: carbonWt.toFixed(2)
        });
    }

    convertToCelaneseValues(input) {
        var userPrefs = this.state.preferences;

        //Pascals to MMH2O
        if (parseInt(userPrefs.lowpdlim, 10) === 2) {
            input.rodepd = Convert.toMMH2O(input.rodepd);
            input.tipepd = Convert.toMMH2O(input.tipepd);
            input.epdCarbon = Convert.toMMH2O(input.epdCarbon);
        }

        if (parseInt(userPrefs.size, 10) === 2) {
            input.tipcirc = Convert.toCircumference(input.tipcirc);
        }

        switch (parseInt(userPrefs.weight, 10)) {
            case 3:
                input.usrange = Convert.fromGtoG100(input.usrange);
                input.rodpgwt = Convert.fromGtoG100(input.rodpgwt);
                break;
            case 2:
                input.usrange = Convert.fromMGtoG100(input.usrange);
                input.rodpgwt = Convert.fromMGtoG100(input.rodpgwt);
                break
            default:
            //do nothing
        }

        if (parseInt(userPrefs.pz, 10) === 2) {
            input.pz = Convert.toDryBasis(input.pz);
        }

        return input;
    }

    // view selected items from the table
    /**
     *
     * viewSelectedItems views the selected items from the table
     *
     * @memberof TowItemSelectionForm
     */
    viewSelectedItems() {
        this.setState({ isTableSelectable: false }, () => {
            this.setState({
                rows: this.state.selectedRows
            });
        });
    }

    // get selected items from the table
    /**
     * getSelectedItems gets the selected items from the table
     *
     * @memberof TowItemSelectionForm
     */
    getSelectedItems() {
        var data = this.state.rows;
        let selectedItems = this.state.selectedItems;
        let result = data.find(element => element.lot === selectedItems[selectedItems.length - 1]);

        if (result) {
            this.setState({
                selectedRows: this.state.selectedRows.concat(result)
            });
        }
    }
    /**
     *onSelectedChange selectedItems are updated and getselectedItems function is called
     *
     * @param {*} selectedItems
     * @memberof TowItemSelectionForm
     */
    onSelectedChange(selectedItems) {
        this.setState({ selectedItems: selectedItems }, () => {
            this.getSelectedItems();
        });
    }

    handleChange(e, fn) {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            if (fn) {
                fn();
            }
        });
    }
    /**
     * handleCircChange converts the circumference to diameter
     *
     * @param {*} e
     * @memberof TowItemSelectionForm
     */
    handleCircChange(e) {
        this.setState({
            diameter: Convert.toDiameter(e.target.value)
        });
    }
    /**
     * handlediachange converts the diameter to circumference
     *
     * @param {*} e
     * @memberof TowItemSelectionForm
     */
    handleDiaChange(e) {
        this.setState({
            circumference: Convert.toCircumference(e.target.value)
        });
    }

    handleLengthChange(e) {
        if (this.toggleTowRange) {
            // this.setState({
            //     towRange:
            // })
        }

        this.handleChange(e);
    }

    getRandomColor() {
        var r = Math.floor(Math.random() * 255);
        var g = Math.floor(Math.random() * 255);
        var b = Math.floor(Math.random() * 255);
        return "rgb(" + r + "," + g + "," + b + ")";
    }

    round5(x, isFloor) {
        if (x < 1) {
            return x;
        }
        return isFloor ? Math.floor(x / 5) * 5 : Math.ceil(x / 5) * 5;
    }

    round50(x, isFloor) {
        return isFloor ? Math.floor(x / 50) * 50 : Math.ceil(x / 50) * 50;
    }


    onRowsSelected(e) {
        if (this.state.isPropsData && e.length) {
            this.setState({
                itemLotVal: e[e.length - 1].itemlot
            });
        }
        var lines = [];

        var minwt = 1000;
        var maxwt = 0;
        var minpd = 1000;
        var maxpd = 0;
        var data = e[0];
        var wtPad = 0;
        var pdPad = 0;
        var wtPref = this.state.preferences.weight;
        var pdPref = this.state.preferences.lowpdlim;

        switch (wtPref) {
            case 2:
                wtPad = 50;
                break;
            case 3:
                wtPad = 0.05;
                break;
            default:
                wtPad = 5
        }

        switch (pdPref) {
            case 2:
                pdPad = 500;
                break;
            default:
                pdPad = 50
        }

        if (!data) {
            this.setState({
                lines: []
            });
            return;
        }

        let title = [];
        title.push(this.state.length + 'mm x ' + this.state.circumference + 'mm');
        title.push(this.state.pref.rodmaker[this.state.preferences.rodMaker]);
        if (this.state.isPaperGlue) {
            title.push(this.state.pgWeight + ' ' + this.state.pref.weight[this.state.preferences.weight - 1].replace(/\(|\)/gi, '') + utils.getTranslationText('form_lbl_pw+glue_weight', 'PW+Glue Weight'));
        }
        title.push(this.state.plugwrapThicknessVal + 'mm ' + utils.getTranslationText('lbl_plugwrap_thickness', 'Plugwrap Thickness'));
        title.push(this.state.plasticizer + '% ' + utils.getTranslationText('lbl_plasticizer', 'Plasticizer'));

        this.setState({
            chartTitle: title.join('\n'),
            xAxisTitle: this.state.isPaperGlue ? utils.getTranslationText('lbl_total_weight', 'Total Weight') : utils.getTranslationText('lbl_tow_weight', 'Tow Only Weight') + " "
        });

        if (this.state.isCarbonLoaded || this.state.isCapsuleChecked) {
            //white filter

            lines.push({
                color: '#B35751',
                title: data.itemlot,
                lineData: [
                    {
                        'x': parseFloat(data.minwt.normal.toFixed(2)),
                        'y': parseFloat(data.minpd.normal.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.normal.toFixed(2)),
                        'y': parseFloat(data.maxpd.normal.toFixed(2))
                    }
                ]
            });

            //carbon filter
            lines.push({
                color: '#4472C4',
                title: data.itemlot + ' (' + (this.state.isCapsuleChecked ? utils.getTranslationText('lbl_filter_capsule', 'Capsule') : utils.getTranslationText('lbl_carbon', 'Carbon')) + ')',
                lineData: [
                    {
                        'x': parseFloat(data.minwt.carbon.toFixed(2)),
                        'y': parseFloat(data.minpd.carbon.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.carbon.toFixed(2)),
                        'y': parseFloat(data.maxpd.carbon.toFixed(2))
                    }
                ]
            });

            //target filter
            lines.push({
                color: '#A1B966',
                title: data.itemlot + `${' (' + utils.getTranslationText('load_items_tbl_hdr_target', 'target') + ')'}`,
                lineData: [
                    {
                        'x': parseFloat(data.tgtwt.normal.toFixed(2)),
                        'y': parseFloat(data.tgtpd.normal.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.tgtwt.carbon.toFixed(2)),
                        'y': parseFloat(data.tgtpd.carbon.toFixed(2))
                    }
                ]
            });

            minwt = lines[0].lineData[0].x;
            maxwt = lines[0].lineData[1].x;
            minpd = lines[0].lineData[0].y;
            maxpd = lines[0].lineData[1].y;

            lines.map(item => {
                let ldata = item.lineData;
                if (ldata[0].x !== 0 && ldata[0].y !== 0) {
                    minwt = Math.min(minwt, ldata[0].x);
                    minpd = Math.min(minpd, ldata[0].y);
                }
                if (ldata[1].x !== 0 && ldata[1].y !== 0) {
                    maxwt = Math.max(maxwt, ldata[1].x);
                    maxpd = Math.max(maxpd, ldata[1].y);
                }

                return true;
            })

            this.setState({
                lines: lines,
                gminwt: minwt - wtPad,
                gmaxwt: maxwt + wtPad,
                gminpd: this.round50(minpd, true) - pdPad,
                gmaxpd: this.round50(maxpd) + pdPad
            });
            return;
        }


        for (var a in e) {
            let data = e[a];
            if (minwt === 0) {
                minwt = data.minwt.normal;
            }
            if (maxwt === 0) {
                maxwt = data.maxwt.normal;
            }
            if (minpd === 0) {
                minpd = data.minpd.normal;
            }
            if (maxpd === 0) {
                maxpd = data.maxpd.normal;
            }

            minwt = Math.min(minwt, data.minwt.normal);
            maxwt = Math.max(maxwt, data.maxwt.normal);
            minpd = Math.min(minpd, data.minpd.normal);
            maxpd = Math.max(maxpd, data.maxpd.normal);

            lines.push({
                color: data.color,
                title: data.itemlot,
                target: [
                    {
                        x: minwt,
                        y: data.tgtpd.normal
                    },
                    {
                        x: maxwt,
                        y: data.tgtpd.normal
                    }
                ],
                lineData: [
                    {
                        'x': parseFloat(data.minwt.normal.toFixed(2)),
                        'y': parseFloat(data.minpd.normal.toFixed(2))
                    },
                    {
                        'x': parseFloat(data.maxwt.normal.toFixed(2)),
                        'y': parseFloat(data.maxpd.normal.toFixed(2))
                    }
                ]
            }
            )
        }


        this.setState({
            lines: lines,
            gminwt: minwt - wtPad,
            gmaxwt: maxwt + wtPad,
            gminpd: this.round50(minpd, true) - pdPad,
            gmaxpd: this.round50(maxpd) + pdPad
        });
    }
    /**
     * hidePlugwrapModal funtion hides the plugwrap window
     *
     * @memberof TowItemSelectionForm
     */
    hidePlugwrapModal() {
        this.setState({ show: false });
    }
    /**
     * onSplitChange changes the height of the splitpane
     *
     * @param {*} height
     * @memberof TowItemSelectionForm
     */
    onSplitChange(height) {
        this.setState({ height: height, lines: this.state.lines, loadItemsClick: false });
    }
    /**
     * downloadFile downloads
     *
     * @memberof TowItemSelectionForm
     */
    downloadFile = () => {
        if (document.body.className.indexOf('ie11') > -1) {
            var svg = document.querySelector(".visualisations");
            var svgData = new XMLSerializer().serializeToString(svg);
            var img = document.createElement("img");
            img.setAttribute("src", "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData))));
            document.body.appendChild(img);
            img.onload = function () {
                var canvas;
                canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                canvas.style.width = img.width + 'px';
                canvas.style.height = img.height + 'px';
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height);
                setTimeout(function () {
                    img.remove();
                }, 1000);
                var blob = canvas.msToBlob();
                window.navigator.msSaveBlob(blob, 'dicomimage.png');
            };
        } else {
            html2canvas(document.querySelector("#graph .wrapper"), { useCORS: true }).then(canvas => {
                if (document.body.className.indexOf('ie11') > -1) {
                    let currentClass = canvas.getAttribute('class');
                    canvas.setAttribute('class', currentClass + ' selected-towitems-graph');
                } else {
                    canvas.classList.add('selected-towitems-graph');
                }
                document.body.appendChild(canvas);
                var aTag = document.getElementById('download');
                aTag.href = canvas.toDataURL("image/png");
                aTag.download = "graph.jpg";
                setTimeout(function () {
                    aTag.click();
                    canvas.remove();
                }, 1000);
            });
        }
    }

    render() {
        return (
            <div>
                <div className="view-heading">
                    <h2 className="text-semibold margin-none">
                        <Translation labelName="menu_tow_item_selection" defaultText="Tow Item Selection" />
                        {this.state.preferences.epdBias !== '' ? <Tag color="#f50" className='m1-left'>EPD Bias : {this.state.preferences.epdBias}</Tag> : null}</h2>
                    {/* <a href='/help/html/Tow_Item_Selection.htm' target="_blank" title="Help" className="help-section">
                        <img
                            src="./images/help-inverse-black.svg"
                            alt="help"
                            className="help-icon" />
                    </a> */}
                </div>
                <div className="container-fluid split">
                    <div className="splitpane-container">
                        <SplitPane split="vertical" minSize={this.state.splitVertical} maxSize={this.state.splitVertical}>
                            <div>
                                <div className={!this.state.collapse ? 'collapse-main collapsed-btn' : 'collapse-main'}>
                                    <Button type="primary" shape="circle" icon="double-left" size="small" className={this.state.collapse ? 'diaplayBlock' : 'displayNone'} onClick={(e) => this.collapseLeft(e)} />
                                    <Button type="primary" shape="circle" icon="double-right" size="small" className={!this.state.collapse ? 'diaplayBlock' : 'displayNone'} onClick={(e) => this.collapseRight(e)} />
                                </div>
                                <div onClick={(e) => this.collapseRight(e)} className={!this.state.collapse ? 'diaplayBlock collapsed' : 'displayNone'} >
                                    <h2><Translation labelName="hdr_rod_properties" defaultText="Rod Properties" /></h2>
                                </div>
                                <input type="text" value="" onChange={(event) => this.handleChange(event)} id="towitem-selection-focus-link" autoFocus={true} />
                                <form className={this.state.collapse ? 'displayBlock tow-form-container' : 'displayNone'} onSubmit={(e) => this.onLoadItemsClick(e)} noValidate>
                                    <div className="tow-selection-form">
                                        <div className="pane-content">
                                            <div className="properties row">
                                                <h3 className="properties__title col-md-12"><Translation labelName="hdr_rod_properties" defaultText="Rod Properties" /></h3>
                                                <InputField
                                                    type="number"
                                                    label={<Translation labelName="lbl_length" defaultText="Length" />}
                                                    name="length"
                                                    units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                                    min='0'
                                                    value={this.state.length}
                                                    id="length"
                                                    onChange={(event) => {
                                                        this.handleChange(event, this.calculateUserRange)
                                                    }
                                                    }
                                                    className="properties__form-field col-md-6"
                                                />
                                                <InputField
                                                    type="number"
                                                    showCheckBox={true}
                                                    label={<Translation labelName="lbl_weight_range" defaultText="Weight Range" />}
                                                    units={this.state.pref.weight[this.state.preferences.weight - 1]}
                                                    name="towRange"
                                                    disabled={!this.state.isTowRange}
                                                    id="towRange"
                                                    value={!this.state.isTowRange ? 0 : this.state.towRange}
                                                    onChecked={this.toggleTowRange}
                                                    onChange={(event) => this.handleChange(event)}
                                                    className="properties__form-field col-md-6"
                                                />
                                                <InputField
                                                    type="number"
                                                    label={<Translation labelName="lbl_circumference" defaultText="Circumference" />}
                                                    name="circumference"
                                                    units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                                    value={this.state.circumference}
                                                    id="circumference"
                                                    min='14'
                                                    max='26'
                                                    informationMessage={<Translation labelName="err_msg_value_must_be_between_14-26_mm" defaultText="value must be between 14-26mm" />}
                                                    onChange={(event) => this.handleChange(event)}
                                                    onBlur={(event) => this.handleCircChange(event)}
                                                    disabled={this.state.preferences.size !== 1}
                                                    className="properties__form-field col-md-6"
                                                />
                                                <InputField
                                                    type="number"
                                                    label={<Translation labelName="lbl_diameter" defaultText="Diameter" />}
                                                    name="diameter"
                                                    units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                                    min='4.46'
                                                    max='8.28'
                                                    informationMessage={<Translation labelName="err_msg_value_not_between_4.46-8.28_mm" defaultText="value is not between 4.46-8.28mm" />}
                                                    value={this.state.diameter}
                                                    id="diameter"
                                                    disabled={this.state.preferences.size !== 2}
                                                    onChange={(event) => this.handleChange(event)}
                                                    onBlur={(event) => this.handleDiaChange(event)}
                                                    className="properties__form-field col-md-6"
                                                />
                                                <InputField
                                                    type="number"
                                                    label={<Translation labelName="lbl_pressure_drop" defaultText="Pressure Drop" />}
                                                    name="pressureDrop"
                                                    units={this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1]}
                                                    allowedZero={true}
                                                    min='0'
                                                    className="properties__form-field col-md-6"
                                                    value={this.state.pressureDrop}
                                                    id="pressureDrop"
                                                    onChange={(event) => this.handleChange(event)}
                                                />
                                                <InputField
                                                    type="number"
                                                    label={<Translation labelName="lbl_plasticizer" defaultText="Plasticizer" />}
                                                    units={<Fragment>(% <Translation labelName={this.state.pref.pz[this.state.preferences.pz - 1] && this.state.pref.pz[this.state.preferences.pz - 1].split(' ').join('').toLowerCase().indexOf('drybasis') >= 0 ? 'lbl_dry_basis' : 'lbl_wet_basis'} defaultText={this.state.pref.pz[this.state.preferences.pz - 1]} />)</Fragment>}
                                                    name="plasticizer"
                                                    maxValue='100'
                                                    allowedZero={true}
                                                    errorMax={<Translation labelName="err_msg_max_value_cannot_be_greater_than_100" defaultText="value cannot be greater than 100" />}
                                                    min='0'
                                                    max='10'
                                                    informationMessage={<Translation labelName="err_msg_value_is_not_between_0-10" defaultText="value is not between 0 - 10" />}
                                                    value={this.state.plasticizer}
                                                    id="plasticizer"
                                                    onChange={(event) => this.handleChange(event)}
                                                    className="properties__form-field col-md-6"
                                                />
                                                <div className="clearfix"></div>

                                                <div className="col-md-6">
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_plugwrap_thickness" defaultText="Plugwrap Thickness" />}
                                                        id="plugwrapThicknessVal"
                                                        units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                                        min='0'
                                                        buttonIcon="setting"
                                                        allowedZero={true}
                                                        onButtonClick={this.showPlugwrapModal}
                                                        name="plugwrapThicknessVal"
                                                        className="properties__form-field plugwrap "
                                                        value={this.state.plugwrapThicknessVal}
                                                        onChange={(event) => this.handleChange(event)}
                                                    />
                                                </div>
                                                <InputField
                                                    type="number"
                                                    label={<Translation labelName="lbl_pw+glue_weight" defaultText="PW+Glue weight" />}
                                                    allowedZero={true}
                                                    showCheckBox={true}
                                                    units={this.state.pref.weight[this.state.preferences.weight - 1]}
                                                    name="pgWeight"
                                                    min='0'
                                                    disabled={!this.state.isPaperGlue}
                                                    id="pgWeight"
                                                    value={this.state.pgWeight}
                                                    onChecked={this.togglePaperGlue}
                                                    onChange={(event) => this.handleChange(event)}
                                                    className="properties__form-field col-md-6"
                                                />

                                                <div className="range">
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_dpf" defaultText="DPF" />}
                                                        name="dpfFrom"
                                                        max={parseFloat(this.state.dpfTo) || 100}
                                                        allowedZero={true}
                                                        errorMinMax={<Translation labelName="err_msg_dpf_Value_cannot_be_zero" defaultText="DPF From value cannot be greater than To value" />}
                                                        min='0'
                                                        value={this.state.dpfFrom}
                                                        id="dpfFrom"
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-range col-md-6"
                                                    />
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_to" defaultText="to" />}
                                                        name="dpfTo"
                                                        maxValue='100'
                                                        min={this.state.dpfFrom}
                                                        errorMax={<Translation labelName="err_msg_max_value_cannot_be_greater_than_100" defaultText="value cannot be greater than 100" />}
                                                        errorMinMax={<Translation labelName="err_msg_max_min_value_cannot_smaller_than_from_value" defaultText="DPF To value cannot be smaller than From value" />}
                                                        value={this.state.dpfTo}
                                                        id="dpfTo"
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-range rangeTo col-md-6"
                                                    />
                                                </div>
                                                <div className="range">
                                                    <InputField
                                                        type="number"
                                                        label={<Fragment><Translation labelName="lbl_capability_range" defaultText="Capability Range" /> (<Translation labelName="units_%" defaultText="%" />)</Fragment>}
                                                        name="acceptableRangeFrom"
                                                        id="acceptableRangeFrom"
                                                        min='0'
                                                        allowedZero={true}
                                                        max={parseFloat(this.state.acceptableRangeTo) || 100}
                                                        errorMinMax={<Translation labelName="err_msg_max_min_capability" defaultText="Acceptable Range From value cannot be greater than To value" />}
                                                        value={this.state.acceptableRangeFrom}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-range col-md-6"
                                                    />
                                                    <InputField
                                                        type="number"
                                                        label=" "
                                                        name="acceptableRangeTo"
                                                        id="acceptableRangeTo"
                                                        min={parseFloat(this.state.acceptableRangeFrom)}
                                                        errorMinMax={<Translation labelName="err_acceptable_greater_than_value" defaultText="Acceptable Range To value cannot be greater than From value" />}
                                                        maxValue={100}
                                                        errorMax={<Translation labelName="err_msg_max_value_cannot_be_greater_than_100" defaultText="value cannot be greater than 100" />}
                                                        value={this.state.acceptableRangeTo}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-range rangeTo col-md-6"
                                                    />
                                                </div>

                                                <div className="col-md-12">
                                                    <Switch
                                                        onChange={this.toggleCarbonCheck}
                                                        checked={this.state.isCarbonChecked}
                                                        size="small"
                                                    />
                                                    <h5 className="properties__form-label carbon-label"><Translation labelName="opt_carbon_properties" defaultText="Carbon Properties" /></h5>
                                                </div>
                                                <div className={this.state.carbonDisplay}>

                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_carbon_loading" defaultText="Carbon Loading" />}
                                                        name="carbonLoading"
                                                        units={<Fragment>(<Translation labelName="units_mg_mm" defaultText="mg/mm" />)</Fragment>}
                                                        id="carbonLoading"
                                                        allowedZero={true}
                                                        min='0'
                                                        value={this.state.carbonLoading}
                                                        onChange={(event) => {
                                                            this.handleChange(event, this.onCarbonLoadBlur)
                                                        }
                                                        }
                                                        className="carbon-field col-md-6"
                                                    />
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_carbon_weight" defaultText="Carbon Weight" />}
                                                        name="carbonWt"
                                                        units={<Fragment>(<Translation labelName="units_lbl_mg" defaultText="mg" />)</Fragment>}
                                                        disabled={true}
                                                        id="carbonWt"
                                                        min='0'
                                                        value={this.state.carbonWt}
                                                        className="carbon-field col-md-6"
                                                    />
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_pd_carbon" defaultText="PD Due to carbon" />}
                                                        name="epdCarbon"
                                                        units={this.state.pref.lowpdCarbonlim[this.state.preferences.lowpdlim - 1]}
                                                        min='0'
                                                        showCheckBox={true}
                                                        onChecked={this.toggleEPDCarbon}
                                                        disabled={!this.state.isEPDCarbon}
                                                        id="epdCarbon"
                                                        value={this.state.epdCarbon}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-field col-md-6"
                                                    />
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_max_carbon_load" defaultText="Max Carbon Load" />}
                                                        name="carbonRange"
                                                        units={<Fragment>(<Translation labelName="units_mg_mm" defaultText="mg/mm" />)</Fragment>}
                                                        min='0'
                                                        showCheckBox={true}
                                                        onChecked={this.toggleCarbonRange}
                                                        disabled={!this.state.isCarbonRange}
                                                        id="carbonRange"
                                                        value={this.state.carbonRange}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-field col-md-6"
                                                    />
                                                    <Alert message={<Translation labelName="msg_info_purely_theoretical_max_carbon_load" defaultText="Purely Theoretical Max Carbon Load" />} type="warning" showIcon />

                                                </div>
                                                <div className="col-md-12">
                                                    <Switch
                                                        onChange={this.toggleCapsuleCheck}
                                                        checked={this.state.isCapsuleChecked}
                                                        size="small"
                                                    />
                                                    <h5 className="properties__form-label carbon-label"><Translation labelName="opt_capsule_properties" defaultText="Capsule Properties" /></h5>
                                                </div>
                                                <div className={this.state.capsuleDisplay + ' cap-props'}>
                                                    <div className="col-md-4">
                                                        <Radio.Group size="small" name="capsuleModes" value={this.state.capsuleMode} onChange={this.toggleCapsuleMode} style={{ marginLeft: '10px' }} buttonStyle="solid">
                                                            <Radio value="1"><Translation labelName="lbl_per_capsule" defaultText="Per Capsule" /></Radio>
                                                            <Radio value="0"><Translation labelName="lbl_capsules_filter_rod" defaultText="All Capsules in Filter Rod" /></Radio>
                                                        </Radio.Group>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <InputField
                                                            type="number"
                                                            label={<Translation labelName="lbl_capsule_weight" defaultText="Capsule Weight" />}
                                                            name="capsuleWt"
                                                            units={this.state.pref.capsule[this.state.capsuleMode].weight}
                                                            allowedZero={true}
                                                            min='0'
                                                            className="properties__form-field col-md-12"
                                                            value={this.state.capsuleWt}
                                                            id="capsuleWt"
                                                            onChange={(event) => this.handleChange(event)}
                                                        />
                                                        <InputField
                                                            type="number"
                                                            label={<Translation labelName="lbl_capsule_pd" defaultText="Capsule PD" />}
                                                            name="capsulePD"
                                                            units={this.state.pref.capsule[this.state.capsuleMode].lowpdlim[this.state.preferences.lowpdlim - 1]}
                                                            allowedZero={true}
                                                            min='0'
                                                            className="properties__form-field col-md-12"
                                                            value={this.state.capsulePD}
                                                            id="capsulePD"
                                                            onChange={(event) => this.handleChange(event)}
                                                        />
                                                        <InputField
                                                            type="number"
                                                            label={<Translation labelName="lbl_no_capsule_per_rod" defaultText="No of Capsules per Rod" />}
                                                            name="capsuleNo"
                                                            allowedZero={true}
                                                            min='0'
                                                            className="properties__form-field col-md-12"
                                                            value={this.state.capsuleNo}
                                                            disabled={this.state.capsuleMode === '0'}
                                                            id="capsuleNo"
                                                            onChange={(event) => this.handleChange(event)}
                                                        />
                                                    </div>
                                                    <div className="clearfix"></div>
                                                </div>
                                                {!this.props.isPropsData ? <div className="col-md-12">
                                                    <label>
                                                        <Switch
                                                            onChange={this.toggleNewTowItemCheck}
                                                            checked={this.state.isNewTowItemChecked}
                                                            size="small"
                                                        />
                                                        <h5 className="properties__form-label carbon-label"><Translation labelName="lbl_new_tow_Item" defaultText="New Tow Item" /></h5>
                                                    </label>
                                                </div> : null}
                                                <div className={this.state.newTowItemDisplay}>
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_dpf" defaultText="DPF" />}
                                                        name="dpf"
                                                        min='0'
                                                        id="dpf"
                                                        value={this.state.dpf}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-field col-md-6"
                                                    />
                                                    <InputField
                                                        type="number"
                                                        label={<Translation labelName="lbl_td" defaultText="TD" />}
                                                        name="td"
                                                        min='0'
                                                        id="td"
                                                        value={this.state.td}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="properties__form-field col-md-6"
                                                    />
                                                    <div className="clearfix"></div>
                                                    <Alert type="warning" showIcon message={<span><Translation labelName="msg_info_predicted_tow_item_questions_please_contact" defaultText="Predicted tow item. For questions please contact" />
                                                        <a href="mailto:towplus.support@celanese.com"><Translation labelName="msg_info_celanese_global_technical_solutions" defaultText="Celanese Global Technical Solutions" /></a></span>} />
                                                </div>
                                                <a href="#" className="clear-all" onClick={this.clearForm}><Translation labelName="link_clear_all" defaultText="Clear All" /></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.state.collapse ? 'spane-buttons' : 'displayNone'}>
                                        <Button type="primary"
                                            disabled={!((parseFloat(this.state.length) &&
                                                (parseFloat(this.state.circumference) || parseFloat(this.state.diameter)) &&
                                                (this.state.isCarbonChecked ? this.state.carbonLoading : true)) &&
                                                (this.state.isNewTowItemChecked ? (parseFloat(this.state.td) && parseFloat(this.state.dpf)) : true) &&
                                                (this.state.dpfTo)
                                            )}
                                            htmlType="submit"
                                            className="calculate-link"
                                            onClick={this.onLoadItemsClick}><Translation labelName="btn_load_items" defaultText="Load Items" /></Button>
                                        {/* <Button type="primary"
                                    className="btn btn-default clr-form"
                                    onClick={this.clearForm}>Clear</Button> */}
                                    </div>
                                </form>
                            </div>
                            <SplitPane split="horizontal" size={300} onDragFinished={this.onSplitChange}>
                                <div style={{ 'width': '100%' }}>
                                    <div className={this.state.toggleTable ? 'displayNone' : 'displayBlock'}>
                                        <TowItemGrid
                                            towItems={this.state.calculatedTowItems}
                                            onTowItemsSelected={this.onRowsSelected}
                                            tableHeight={this.state.height}
                                            isCarbon={this.state.isCarbonLoaded || this.state.isCapsuleChecked}
                                            towItemLotSelected={this.state.towItemLot}
                                            loadItemsClick={this.state.loadItemsClick}
                                            toFilterTowItemData={this.state.toFilterTowItemData}
                                            isPropsData={this.state.isPropsData}
                                        />
                                    </div>
                                    <div className={!this.state.toggleTable ? 'displayNone' : 'displayBlock'}>
                                        <div className="emptyItems">
                                            <h3><Icon type="pic-left" theme="outlined" /><span><Translation labelName="info_load_Items_to_view_tow_items" defaultText="Click on Load Items to view tow items " /></span></h3>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ textAlign: 'center', minHeight: this.state.lines.length ? '490px' : '' }}>
                                        <div className={this.state.lines.length ? 'displayBlock' : 'displayNone'} id="graph">
                                            <CustomGraph
                                                title={this.state.chartTitle}
                                                isCarbon={this.state.isCarbonLoaded || this.state.isCapsuleChecked}
                                                lines={this.state.lines}
                                                size={{ height: 470, width: 650 }} axis={{
                                                    x: {
                                                        min: this.state.gminwt,
                                                        max: this.state.gmaxwt,
                                                        name: this.state.xAxisTitle + this.state.pref.weight[this.state.preferences.weight - 1]
                                                    },
                                                    y: {
                                                        min: this.state.gminpd,
                                                        max: this.state.gmaxpd,
                                                        name: utils.getTranslationText('lbl_epd', 'EPD') + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1]
                                                    }
                                                }}
                                            />
                                            <Button className="export-graph" type="primary" shape="circle" icon="download" size="small" onClick={this.downloadFile} />
                                        </div>
                                        <div className={!this.state.lines.length ? 'displayBlock' : 'displayNone'}>
                                            <div className="emptyItems">
                                                <h3><Icon type="line-chart" theme="outlined" /><span><Translation labelName="info_tow_items_to_view_it_on_graph" defaultText="Select tow items to view it on graph" /></span></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplitPane>
                        </SplitPane>

                    </div>
                </div>
                <a href='#' id='download' className='download-graph-hidden'></a>
                {this.state.visibleplugwrap && <Modal
                    visible={this.state.visibleplugwrap}
                    footer={null}
                    width="1200px"
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness
                        rowSelectionDisable={true}
                        updatePlugwrapValue={this.updatePlugwrapValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}>
                    </PlugwrapThickness>
                </Modal>}
                {this.props.isPropsData ? <button
                    value="select"
                    type="button"
                    className="btn btn-default filter-towitem-select-btn"
                    onClick={() => {
                        this.props.towItemSelect(this.state.itemLotVal)
                        this.props.handleTowItemSelectionCancel()
                    }}><Translation labelName="btn_select" defaultText="SELECT" /></button> : null}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    onTowItemsSelected: (data) => dispatch(loadTowItems(data))
});

const mapStateToProps = ({ loggedUserState, towItemsState }) => ({
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    userRole: loggedUserState.userRole,
    itemData: towItemsState.itemData
});

export default connect(mapStateToProps, mapDispatchToProps)(TowItemSelectionForm);

TowItemSelectionForm.propTypes = {
    userRole: PropTypes.string,
    itemData: PropTypes.array,
    onTowItemsSelected: PropTypes.func,
    preferences: PropTypes.object,
    towItemProps: PropTypes.object,
    towItemSelect: PropTypes.func,
    isPropsData: PropTypes.bool,
    handleTowItemSelectionCancel: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/containers/TowItemSelectionForm/index.js